import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import { Form } from 'formik';
import { useWritingForm } from '../../hooks/useWritingForm';
import { ScholarlyProjectCitingSection } from '../../components/citing/ScholarlyProjectCiting';
import { ContributorSection } from '../../components/ContributorSection';
import { RecommendationBar } from '../../components/Shared';
import GenericSection from '../../components/GenericSection';
import { CONTRIBUTOR_ROLE_OPTIONS, SCHOLARLY_FORM_PUB_INFO_SECTION_FIELD_LIST, SCHOLARLY_FORM_PUB_INFO_SECTION_NAME, SCHOLARLY_FORM_PUB_INFO_SECTION_TITLE, SCHOLARLY_FORM_PUB_INFO_TEST_ID, SCHOLARLY_FORM_TEST_ID } from './constants';
import { MoreOptionsSection } from '../../components/MoreOptions';
import { SourceType } from '../../types';

// Component to render Scholarly Project form
var ScholarlyProjectForm = function ScholarlyProjectForm(_ref) {
  _objectDestructuringEmpty(_ref);
  useWritingForm(SourceType.SCHOLARLY_PROJECT);
  return /*#__PURE__*/React.createElement(Form, {
    "data-test": SCHOLARLY_FORM_TEST_ID
  }, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(ScholarlyProjectCitingSection, null), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: CONTRIBUTOR_ROLE_OPTIONS
  }), /*#__PURE__*/React.createElement(GenericSection, {
    name: SCHOLARLY_FORM_PUB_INFO_SECTION_NAME,
    fieldList: SCHOLARLY_FORM_PUB_INFO_SECTION_FIELD_LIST,
    sectionTitle: SCHOLARLY_FORM_PUB_INFO_SECTION_TITLE,
    "data-test": SCHOLARLY_FORM_PUB_INFO_TEST_ID,
    selectedTab: "" /** not tabs in this form */
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default ScholarlyProjectForm;